///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.promo_team = abcsetup.dashboard.promo_team || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.promo_team = {
    init: function ()
    {
        $('#promo-promoitems-search-modal').on('click', '#search', function () {
            // Disable the button
            $(this).prop("disabled", true);
            $(this).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...');

            // search using input fields
            abcsetup.dashboard.promo_team.render_search_terms();
            var fields = $('#promo_search').serialize();
            console.log('fields-> ',fields);
            axios.get('/api/promo/search/?'+fields).then( response => {
                console.log('response: ',response.data);
                $('#app_data_tables_promo_promo_data_tableall_wrapper table').DataTable().columns(0).search( response.data.length ? response.data : ['','']);
                $('#app_data_tables_promo_promo_data_tableall_wrapper table').DataTable().clear().draw();
                $('#promo-promoitems-search-modal').modal('hide');

                // Re-enable the button
                $(this).prop("disabled", false);
                $(this).html('Search');
            });
        });

        $('#promo-promoitems-search-modal').on('click', '#clear', function () {
            // Clear all input fields
            $(this).closest('#promo-promoitems-search-modal')
                .find(':input')
                .val('');

            // Disable the button
            $(this).prop("disabled", true);
            $(this).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...');

            // search using input fields
            abcsetup.dashboard.promo_team.render_search_terms();
            var fields = $('#promo_search').serialize();
            console.log('fields-> ',fields);
            axios.get('/api/promo/search/?'+fields).then( response => {
                console.log('response: ',response.data);
                $('#app_data_tables_promo_promo_team_all_data_table').DataTable().columns(0).search( response.data.length ? response.data : ['','']);
                $('#app_data_tables_promo_promo_team_all_data_table').DataTable().clear().draw();
                $('#promo-promoitems-search-modal').modal('hide');

                // Re-enable the button
                $(this).prop("disabled", false);
                $(this).html('Clear');
            });
        });

        $(document).on('click', '.btn-danger.delete_promo', function (e) {
            var $this = $(this);
            var promo_id = $(this).attr('data-id');
            var promo_name = $(this).attr('data-name');

            abcsetup.alerts.confirm('Delete Promotion', 'Are you sure you want to remove Promotion: '+promo_name+' ?', function (resp) {
                abcsetup.blockUI(true);
                if (resp) {
                    abcsetup.dashboard.promo_team.delete(promo_id, () => {
                        $this.closest('.datatable').DataTable().clear().draw();
                    });
                }
            });
        });
    },

    /**
     *
     * @param {*} id
     */
    delete: function(id, callback = null) {
        axios.delete('/promo/' + id).then(callback ? callback : response => {
            $("#app_data_tables_promo_promo_team_open_data_table_filter .btn.buttons-reset").trigger('click');
        });
    },

    render_search_terms: function(){
        $('.search_terms').remove();
        var search_terms = '';
        var label = '';
        var val = '';
        $('#promo_search').find(':input').each(function(){
            if ($(this).val()){
                val = $(this).val();
                if ($(this).find('option:selected') && $(this).find('option:selected').text()){
                    val = $(this).find('option:selected').text();
                }
                label = $('label[for="' + $(this).attr('id') + '"]').html();
                search_terms += "<b>"+label+"</b>: "+val+" ";
            }
        });
        console.log('search_terms:',search_terms);
        if (search_terms){
            search_terms = "Results filtered on : " + search_terms;
            $('#app_data_tables_promo_promo_team_all_data_table').before(
                $('<div class="alert alert-success search_terms"></div>').html(search_terms)
            );
        }
    },
}
